import React, { useState } from 'react';
import { TableCell } from '@material-ui/core';
import StoreDateStatusCell from './StoreDateStatusCell';

export default function StalePriceLastCollectedCell({ row, onStatusSaved }) {
  const [cellColor, setCellColor] = useState('');

  return (
    <TableCell
      style={{
        position: 'relative',
        backgroundColor: cellColor,
        cursor: row.external_link ? 'pointer' : 'default',
      }}
    >
      <StoreDateStatusCell
        cellData={{
          company_product_id: row.company_product_id,
          store_id: row.store_id,
          date: row.current_updated_at,
          not_updated: 1,
          external_link: row.external_link,
          store_postal: row.store_postal,
        }}
        setCellColor={setCellColor}
        onStatusSaved={onStatusSaved}
        reportContext={row}
      />
    </TableCell>
  );
}
